import React, { useRef, useState } from 'react';
import { useRootLoaderData } from '../../common/utils/useRootLoaderData';
import { UPDATE_CLIENT_SETTING } from '../../common/utils/useClientSettings';
import ProgressButton from '../../common/components/ProgressButton';
import { Input } from '../../common/components/ui/input';
import { Label } from '../../common/components/ui/label';

export function TgsDevToolsSettings() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [settingName, setSettingName] = useState('');
  const [settingValue, setSettingValue] = useState('');
  const settingValueRef = useRef<HTMLInputElement>(null);
  const { webshopSettings } = useRootLoaderData();

  async function handleSubmitSetting(e: React.SubmitEvent<HTMLFormElement>) {
    e.preventDefault();
    setIsSubmitting(true);
    await UPDATE_CLIENT_SETTING(settingName, settingValue);
    // UPDATE_CLIENT_SETTING triggers a page reload
  }

  function fillSettingNameToForm(setting) {
    setSettingName(setting.setting);
    if (settingValueRef.current) {
      settingValueRef.current.focus();
    }
  }

  return (
    <div className={'flex gap-8'}>
      <div className={'flex gap-4 flex-col'}>
        <h2>Customer Webshop Settings</h2>
        <h2>Update Custom Setting</h2>
        <form onSubmit={handleSubmitSetting} className={'flex gap-4 flex-col'}>
          <div>
            <Label htmlFor="settingName">Setting Name</Label>
            <Input
              id="settingName"
              type="text"
              value={settingName}
              onChange={e => setSettingName(e.target.value)}
              className="text-black"
              required
            />
          </div>
          <div>
            <Label htmlFor="settingValue">Setting Value</Label>
            <Input
              id="settingValue"
              ref={settingValueRef}
              type="text"
              value={settingValue}
              onChange={e => setSettingValue(e.target.value)}
              className="text-black"
              required
            />
          </div>
          <ProgressButton inProgress={isSubmitting} type="submit">
            Submit Setting
          </ProgressButton>
        </form>
        <hr />
      </div>
      <div>
        <h3>Settings</h3>
        <div className={'flex flex-col text-sm'}>
          {webshopSettings.map(setting => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
            <div
              key={setting.setting}
              className={'flex gap-4 cursor-pointer hover:bg-muted/40 px-1 py-0.5 rounded'}
              onClick={() => fillSettingNameToForm(setting)}
            >
              <div className={'text-sm min-w-[180px]'}>{setting.setting}</div>
              <div>{JSON.stringify(setting.value)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
